module.exports = __webpack_public_path__ + "static/media/profile_martin.37193a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/profile_martin.png
// module id = 1120
// module chunks = 4